import { ReactNode } from "react";
import { AlertOutlinedIcon } from "@icons";
import { useCopyToClipboard } from "@hooks/useCopyToClipboard";
import { HStack } from "../HStack/HStack";
import { Button } from "../Button/Button";
import { VStack } from "../VStack/VStack";
import styles from "./ErrorToast.module.scss";

interface Props {
    children: ReactNode;
    traceId?: string;
}

export const ErrorToast = ({ children, traceId }: Props) => {
    const copyToClipboard = useCopyToClipboard();

    return (
        <VStack gap={12} className={styles.errorToast}>
            <HStack gap={8} align="start" className={styles.messageRow}>
                <AlertOutlinedIcon className={styles.icon} />
                <div className={styles.message}>{children}</div>
            </HStack>
            {traceId ? (
                <>
                    <HStack gap={8} align="start" className={styles.traceIdRow}>
                        <span className={styles.iconSpacer} aria-hidden />
                        <span className={styles.traceId}>ID: {traceId}</span>
                    </HStack>
                    <HStack justify="end" className={styles.actions}>
                        <Button
                            variant="primary"
                            size="md"
                            onClick={() => void copyToClipboard(traceId)}
                        >
                            Copy ID
                        </Button>
                    </HStack>
                </>
            ) : null}
        </VStack>
    );
};
